import styled from 'styled-components';

const TotalsLine = styled.div`
  width: 278.5px;
  height: 1px;
  background: var(--grey300); ;
`;
export default TotalsLine;
